module.exports = __webpack_public_path__ + "media/images/badges/virtual-connections-100-af57fa1701c8d226c8d2a0bc997ebb63.svg";